import type { Route } from "./+types/$locale.rental-agreement";
import { buildSeoMeta } from "@/components/seo/meta";

export { RentalAgreementPage as default } from "@/features/legal/routes/RentalAgreementPage";

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Rental Agreement",
        description:
            "Rental Agreement for Stork Rentals baby equipment rental service - equipment care, deposits, returns, and liability.",
        path: "/rental-agreement",
        locale,
        availableLocales: [{ code: "en" }],
    });
}
